/* Profile toggle: opt in to Quick $15 withdrawals ($15 fee → Restock pot). */
import { useState } from "react";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Switch } from "@/components/ui/switch";
import { Zap } from "lucide-react";

export default function Quick15Card() {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const on = !!user?.quick15_enabled;

  const toggle = async (enabled) => {
    setBusy(true); setErr("");
    try { await api.post("/quick15/settings", { enabled }); await refresh(); }
    catch (e) { setErr(formatErr(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-6 bg-linen border border-sand rounded-2xl p-8" data-testid="quick15-card">
      <div className="text-xs uppercase tracking-[0.2em] font-semibold text-sage inline-flex items-center gap-1.5"><Zap className="w-3.5 h-3.5" /> Quick $15 withdrawals</div>
      <div className="mt-3 flex items-start justify-between gap-6">
        <p className="text-sm text-moss max-w-lg">
          Adds a <strong>Quick $15</strong> button to your Vaults page: pull $15 from a rainy-day fund into Spending, up to 3 times a day.
          Each pull charges a <strong>$15 fee</strong> from Spending into the <strong>Restock pot</strong> on your Inventory page — so every shortcut still saves toward groceries and supplies.
          {user?.is_admin && <span className="block text-[11px] text-sage mt-1">On by default for the admin account.</span>}
        </p>
        <Switch checked={on} disabled={busy} onCheckedChange={toggle} data-testid="quick15-toggle" />
      </div>
      {err && <div className="text-xs text-clay mt-2" data-testid="quick15-card-error">{err}</div>}
    </div>
  );
}
